export const REGISTER_BASLANGIC = {
    name: "",
    email: "",
    password: "",
};
export const LOGIN_BASLANGIC = {
    email: "",
    password: "",
};